// utils/hmac.ts
export async function generateHmacSHA256(
	key: string,
	message: string
): Promise<string> {
	const enc = new TextEncoder()

	// importa chiave come CryptoKey
	const cryptoKey = await crypto.subtle.importKey(
		'raw',
		enc.encode(key),
		{ name: 'HMAC', hash: 'SHA-256' },
		false,
		['sign']
	)

	// calcola HMAC
	const signature = await crypto.subtle.sign(
		'HMAC',
		cryptoKey,
		enc.encode(message)
	)

	// ritorna in hex
	return Array.from(new Uint8Array(signature))
		.map((b) => b.toString(16).padStart(2, '0'))
		.join('')
}
